<form (ngSubmit)="onSubmit()" #form="ngForm">
  <div class="modal-header">
    <h5 class="modal-title">{{ formDetail.titleMessage.messageKey | messageTranslate }}</h5>
    <app-button type="submit"
                class="ms-auto"
                label="Send"
                [buttonNgClass]="formDetail.buttonClass"
                [loading]="sending"
                [disabled]="!form.valid"/>
    <button type="button" class="btn-close ms-1" aria-label="Close" (click)="activeModal.dismiss('close')"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <app-email-ticket name="email"
                          [ngModel]="ticket"
                          [emailType]="emailType"
                          [campaignName]="campaignName"
                          (sent)="onSent($event)"/>
      </div>
    </div>
  </div>
</form>
